/* eslint-disable react/prop-types */
import React, { createContext, useContext, useState } from "react";
import { isEqual } from "lodash";

import useTemplates from "./useTemplates/useTempaltes";
import useSubscriptions from "./useSubscriptions/useSubscriptions";
import { EVENT_ON_CREATE_TEMPLATE } from "../consts";

const SearchTemplateContext = createContext();

// eslint-disable-next-line require-jsdoc
const SearchTemplateProvider = ({ children, templateType }) => {
    const [saveTemplateDialogOpen, setSaveTemplateDialogOpen] = useState(false);
    const [dataGridConfig, setDataGridConfig] = useState();
    const [nestedDataGridConfig, setNestedDataGridConfig] = useState();
    const [dataGridConfigIsDirty, setDataGridConfigIsDirty] = useState(false);
    const [formStateIsDirty, setFormStateIsDirty] = useState(false);
    const [formState, setFormState] = useState();
    const [selectedTemplate, setSelectedTemplate] = useState();
    const { subscribeEvent, emitEvent, getSubscriptions } = useSubscriptions();

    const templatesHook = useTemplates({
        templateType,
        setSelectedTemplate,
        setDataGridConfig,
        setNestedDataGridConfig,
        setDataGridConfigIsDirty,
        setFormStateIsDirty,
        emitEvent,
    });

    // eslint-disable-next-line require-jsdoc
    const updateFormState = (newState) => {
        /*
         * Detect if the formState change is template loading action.
         * We can get it from comparison of selected template and updated state.
         * In this case setting the dirty state of the form is not necessary.
         * For comapring the values, the form state needs to be converted to JSON and parsing back,
         * because the datePicker fields use moment objects in state, but them template contains date strings.
         */
        if (
            selectedTemplate &&
            isEqual(
                JSON.parse(JSON.stringify(newState)),
                JSON.parse(selectedTemplate.content).searchFormState,
            )
        ) {
            setFormStateIsDirty(false);
        } else {
            setFormStateIsDirty(true);
        }

        setFormState(newState);
    };

    // eslint-disable-next-line require-jsdoc
    const createTemplateContent = () => {
        if (
            !formState &&
            getSubscriptions(EVENT_ON_CREATE_TEMPLATE).length > 0
        ) {
            // React-hook-form is used. Getting form state via an event subscription
            const formStateByEvent = emitEvent(EVENT_ON_CREATE_TEMPLATE)[0];
            return {
                searchFormState: formStateByEvent || {},
                resultTableConfig: dataGridConfig || {},
                ...(nestedDataGridConfig
                    ? { nestedResultTableConfig: nestedDataGridConfig }
                    : {}),
            };
        }

        return {
            searchFormState: formState || {},
            resultTableConfig: dataGridConfig || {},
            ...(nestedDataGridConfig
                ? { nestedResultTableConfig: nestedDataGridConfig }
                : {}),
        };
    };

    const ctx = {
        templateType,
        saveTemplateDialogOpen,
        dataGridConfig,
        nestedDataGridConfig,
        dataGridConfigIsDirty,
        formStateIsDirty,
        formState,
        selectedTemplate,
        setDataGridConfig,
        setNestedDataGridConfig,
        setSaveTemplateDialogOpen,
        setDataGridConfigIsDirty,
        setFormStateIsDirty,
        updateFormState,
        setSelectedTemplate,
        createTemplateContent,
        subscribeEvent,
        emitEvent,
        ...templatesHook,
    };

    return (
        <SearchTemplateContext.Provider value={ctx}>
            {children}
        </SearchTemplateContext.Provider>
    );
};

export default SearchTemplateProvider;

// eslint-disable-next-line require-jsdoc
export const useSearchTemplateProvider = () =>
    useContext(SearchTemplateContext);

export { TemplateType } from "../consts";
